function formatNumber (n) {
  const str = n.toString()
  return str[1] ? str : `0${str}`
}

export function formatTime (date) {
  let tdate = new Date(parseInt(date) * 1000)
  const year = tdate.getFullYear()
  const month = tdate.getMonth() + 1
  const day = tdate.getDate()

  const hour = tdate.getHours()
  const minute = tdate.getMinutes()
  const second = tdate.getSeconds()

  const t1 = [year, month, day].map(formatNumber).join('.')
  const t2 = [hour, minute, second].map(formatNumber).join(':')
  return `${t1} ${t2}`
}

export function formatDate (date) {
  let tDate = new Date(parseInt(date) * 1000)
  const year = tDate.getFullYear()
  const month = tDate.getMonth() + 1
  const day = tDate.getDate()

  const t1 = [year, month, day].map(formatNumber).join('.')

  return `${t1}`
}

export function formatNumInTenThousand (data) {
  const num = parseInt(data)
  const num2 = num / 10000
  if (num2 >= 1) {
    return Math.round(num2 * 100) / 100 + '万'
  } else {
    return num
  }
}

export function originalPrice (data) {
  const num = parseInt(data)
  const num2 = num * 2
  return num2
}

// 获取cookie、
export function getCookie (name) {
  var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)') // eslint-disable-line
  if (arr = document.cookie.match(reg)) { // eslint-disable-line
    return (arr[2])
  } else {
    return null
  }
}

// 设置cookie,增加到vue实例方便全局调用
export function setCookie (cName, value, expiredays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = cName + '=' + escape(value) +
    ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
}

// 删除cookie
export function delCookie (name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}

export function isWechat () {
  return /windowswechat/.test(navigator.userAgent.toLowerCase())
}



// WEBPACK FOOTER //
// ./src/utils/index.js